import { WageLevel } from "@api/shared-runtime/enums";
import { Badge } from "@/components/ui/badge";
import { formatCurrency } from "@/features/expense/utils/expense-schema";
import type { OrgApprovedTimeEntry } from "../../hooks/useApprovedTimeEntries";

interface PayableAmountProps {
  entry: Pick<OrgApprovedTimeEntry, "payableAmount" | "wageLevel">;
}

/** Approved amount for an entry; renders nothing when it has no amount. */
export function PayableAmount({ entry }: PayableAmountProps) {
  const isCustomWage = entry.wageLevel === WageLevel.Custom;
  if (entry.payableAmount === null && !isCustomWage) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {entry.payableAmount !== null && (
        <span className="whitespace-nowrap text-sm font-semibold text-slate-900">
          {formatCurrency(entry.payableAmount)}
        </span>
      )}
      {isCustomWage && (
        <Badge
          variant="outline"
          className="border-amber-200 bg-amber-50 text-xs text-amber-800"
        >
          Custom wage
        </Badge>
      )}
    </div>
  );
}
